customElements.whenDefined('carousel-slider').then(() => {
  
  class AccessibleCarouselSlider extends CarouselSlider {
    constructor() {
      super();
      this.statusElement = null;
      this.currentIndex = 0;
    }

    init() {
      super.init();
      
      this.statusElement = this.querySelector('[role="status"]');
      
      if (this.statusElement && this.slides && this.slides.length > 0) {
        this.updateStatusMessage();
      }
    }


    handleScroll() {
      super.handleScroll();
      
      if (this.statusElement) {
        this.updateStatusMessage();
      }
    }

    updateStatusMessage() {
      if (!this.statusElement || !this.slides || !this.slides.length) return;

      const currentStart = (this.currentIndex || 0) + 1;
      const slidesPerPage = this.slidesPerPage || 1;
      const currentEnd = Math.min((this.currentIndex || 0) + slidesPerPage, this.slides.length);
      const total = this.slides.length;

      let message;
      if (slidesPerPage === 1) {
        message = `Showing collection ${currentStart} of ${total}`;
      } else if (currentEnd === currentStart) {
        message = `Showing collection ${currentStart} of ${total}`;
      } else {
        message = `Showing collections ${currentStart} to ${currentEnd} of ${total}`;
      }

      this.statusElement.textContent = message;
    }

    handleNavClick(evt) {
      super.handleNavClick(evt);
      
      setTimeout(() => {
        if (this.statusElement) {
          this.updateStatusMessage();
        }
      }, 300);
    }

    initSlider() {
      super.initSlider();
      
      if (this.statusElement && this.slides && this.slides.length > 0) {
        this.updateStatusMessage();
      }
    }
  }

  customElements.define('accessible-carousel-slider', AccessibleCarouselSlider);
});
